import { FormControl, Input, InputLabel, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../HardwareDetails/HardwareDetails";
import { ActionsModal } from "../ActionsModal";
import { generateHardwareNotListedIssueTicket } from "../../../helper/generateTicket";
import { createZendeskTicket } from "../../../resource/bff";
import { ActionStatusContext } from "../Actions";

export default function HardwareNotListedModal(props) {
  const [hardware, setHardware] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const userDetails = useContext(UserDetailsContext);
  const { setIsLoading, showActionResponse, setIsActionSuccess } =
    useContext(ActionStatusContext);

  const onSubmit = async (event) => {
    event.preventDefault();
    props.onClose();
    setIsLoading(true);
    const ticket = generateHardwareNotListedIssueTicket(
      userDetails.workingOffice.country,
      userDetails.homeOffice.name,
      userDetails.homeOffice.country,
      userDetails.employeeNumber,
      hardware,
      additionalInfo
    );
    try {
      await createZendeskTicket(ticket);
      setIsActionSuccess(true);
    } catch (error: any) {
      setIsActionSuccess(false);
    } finally {
      setHardware("");
      setAdditionalInfo("");
    }
    setIsLoading(false);
    showActionResponse();
  };

  return (
    <ActionsModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      heading={"Report"}
      title={"Hardware not listed"}
      isFormValid={hardware != ""}
      onSubmit={onSubmit}
    >
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "25px" }}
      >
        <InputLabel id={"specify-hardware-not-listed-label"}>
          <Typography display={"inline"}>Specify hardware</Typography>
          <Typography display={"inline"} color={"red"}>
            *
          </Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"specify-hardware-not-listed-label"}
          value={hardware}
          onChange={(e) => setHardware(e.target.value)}
        />
      </FormControl>
      <FormControl
        variant="standard"
        sx={{ minWidth: 400, marginBottom: "32px" }}
      >
        <InputLabel id={"additional-information-label"}>
          <Typography display={"inline"}>Additional Information</Typography>
        </InputLabel>
        <Input
          multiline
          maxRows={5}
          aria-labelledby={"additional-information-label"}
          value={additionalInfo}
          onChange={(e) => setAdditionalInfo(e.target.value)}
        />
      </FormControl>
    </ActionsModal>
  );
}
